import React from 'react';
import Datetime from "react-datetime";
import withStyles from 'isomorphic-style-loader/withStyles'
import { injectIntl, defineMessages, FormattedMessage } from 'react-intl';
import {customisedIntlFormatMessage} from '../../utils/helpers';
import { compose } from 'redux';
import style from './AddSibling.scss';
import moment from 'moment';

const localMessages = defineMessages({
  addSiblingBtn: {
    id: 'addsibling.addSiblingBtn',
    defaultMessage: 'Add another sibling',
    description: 'Add another sibling',
  },
  removeSiblingBtn: {
    id: 'addsibling.removeSiblingBtn',
    defaultMessage: 'Remove sibling',
    description: 'Remove sibling',
  },
  siblingDesc: {
    id: 'addsibling.siblingDesc',
    defaultMessage: 'Tell us more about the sibling.',
    description: 'Tell us more about the sibling.',
  },
  fname: {
    id: 'addsibling.fname',
    defaultMessage: 'First name',
    description: 'First name',
  },
  lname: {
    id: 'addsibling.lname',
    defaultMessage: 'Last name',
    description: 'Last name',
  },
  dob: {
    id: 'addsibling.dob',
    defaultMessage: 'Date of birth',
    description: 'Date of birth',
  },
  grade: {
    id: 'addsibling.grade',
    defaultMessage: 'Grade',
    description: 'Grade',
  },
  cgrade: {
    id: 'addsibling.cgrade',
    defaultMessage: 'Current Grade',
    description: 'Current Grade',
  },
  osis: {
    id: 'addsibling.osis',
    defaultMessage: 'OSIS ID (optional)',
    description: 'OSIS ID (optional)',
  },
})

class AddSibling extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    let {idx, sibling, addSibling, removeSibling} = this.props;
    let key = `sibling-div-${idx}`, siblingFName = `sibling-fname-${idx}`, siblingLName = `sibling-lname-${idx}`;
    let siblingDOB = `sibling-dob-${idx}`, siblingGrade= `sibling-grade-${idx}`, siblingOSIS=`sibling-osis-${idx}`;
    let isRtl = false;
    if (this.props.intl && (this.props.intl.locale == 'ar' || this.props.intl.locale == 'ur')) {
      isRtl = true;
    }
    let floatStyle = isRtl ? {float: 'left'} : {float: 'right'};
    return (
      <div key={key} className={style.siblingDiv} >
        <span className="sibling-header"><FormattedMessage {...localMessages.siblingDesc} /></span>
        <span className={style.removeSiblingSpan} style={floatStyle}>
          <button
            type="button"
            onClick={removeSibling.bind(this, idx)}
            className={style.removeSiblingBtn}
          >
            <FormattedMessage {...localMessages.removeSiblingBtn} />
          </button>
        </span>
        <br />
        <label htmlFor={siblingFName}><FormattedMessage {...localMessages.fname} /></label>
        <input type="text" id={siblingFName} data-id={idx} className={style.sublingInputs} name={siblingFName} maxlenght="30" value={sibling.fname} onChange={(e) => this.props.handleSiblingChange(idx, 'fname', e.target.value)} required />
        <label htmlFor={siblingLName}><FormattedMessage {...localMessages.lname} /></label>
        <input type="text" id={siblingLName} className={style.sublingInputs} data-id={idx} name={siblingLName} maxlenght="30" value={sibling.lname} onChange={(e) => this.props.handleSiblingChange(idx, 'lname', e.target.value)} required />
        <label htmlFor={siblingDOB}><FormattedMessage {...localMessages.dob} /></label>
        <Datetime
          dateFormat="MM-DD-YYYY"
          timeFormat={false}
          value={sibling.dob ? moment(sibling.dob, 'MM-DD-YYYY').format('MM-DD-YYYY') : ''}
          inputProps={{id: siblingDOB, required: true }}
          onChange={(e) => this.props.handleDOB(idx, e)}
        />
        <label htmlFor={siblingGrade}><FormattedMessage {...localMessages.cgrade} /></label>
        <select id={siblingGrade} name={siblingGrade} value={sibling.grade} onChange={(e) => this.props.handleSiblingChange(idx, 'grade', e.target.value)} required>
          <option key= "no_grade" value="">{customisedIntlFormatMessage(this.props.intl, localMessages.grade)}</option>
          {this.props.grades.map((grade) => (
            <option key= {grade.id} value={grade.id}>{grade.name}</option>
          ))}
        </select>
        <label htmlFor={siblingOSIS}><FormattedMessage {...localMessages.osis} /></label>
        <input type="number" id={siblingOSIS} className={style.sublingInputs} data-id={idx} name={siblingOSIS} maxlenght="9" value={sibling.osis}  onChange={(e) => this.props.handleSiblingChange(idx, 'osis', e.target.value)} required="" />
        <button
          type="button"
          onClick={addSibling}
          className={style.addAnotherSiblingBtn}
        >
          <FormattedMessage {...localMessages.addSiblingBtn} />
        </button>
      </div>
    )
  }
}

export default compose(
  injectIntl,
  withStyles(style),
)(AddSibling);